import React from "react";
import LawyerImage from "./img/scout.png";
import About from "./About";
import heroImage from "./img/BlogPageHeroImage.png";

const Bulbul = () => {
  return (
    <div>
      <section id="home" className="my-10 lg:h-full lg:max-h-500 bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <img src={heroImage} style={{ width: "100%" }} alt="heroImage" />
            </div>
          </div>
        </div>
        <About />
      </section>
    </div>
  );
};

export default Bulbul;
